module.exports = __webpack_public_path__ + "media/assets/images/flags/sc-ae4835cc6babd2821c5eb825071dbac6.svg";